import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../../firebase.js';
import { ExternalLink, Gift } from 'lucide-react';
import '../../styles/ClubBeneficios.css';

const ClubBeneficios = () => {
    const [benefits, setBenefits] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBenefits = async () => {
            try {
                const q = query(collection(db, 'platform_benefits'), orderBy('createdAt', 'desc'));
                const snapshot = await getDocs(q);
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setBenefits(data);
            } catch (error) {
                console.error("Error loading benefits:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchBenefits();
    }, []);

    if (loading) return <div className="main-panel"><p>Cargando beneficios...</p></div>;

    return (
        <div className="main-panel">
            <h2 className="section-title">Club de Beneficios</h2>
            <p style={{ color: '#6b7280', marginBottom: '20px' }}>Accede a descuentos y oportunidades exclusivas con nuestros aliados.</p>

            {benefits.length === 0 ? (
                <div className="empty-state-card">
                    <Gift size={48} color="#ccc" />
                    <p>Próximamente encontrarás beneficios exclusivos aquí.</p>
                </div>
            ) : (
                <div className="benefits-grid">
                    {benefits.map(benefit => (
                        <div key={benefit.id} className="benefit-card">
                            <div className="benefit-image-container">
                                {benefit.imageUrl ? (
                                    <img src={benefit.imageUrl} alt={benefit.title} className="benefit-image" />
                                ) : (
                                    <div className="benefit-placeholder-image">
                                        <Gift size={32} color="#fff" />
                                    </div>
                                )}
                                <span className="benefit-category">{benefit.category}</span>
                            </div>
                            <div className="benefit-content">
                                <h3>{benefit.title}</h3>
                                <p>{benefit.description}</p>
                                <a href={benefit.url} target="_blank" rel="noopener noreferrer" className="benefit-button">
                                    Visitar Sitio <ExternalLink size={16} />
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ClubBeneficios;